module.exports = __webpack_public_path__ + "img/patrol-on.aaeec8ee.svg";